import { motion } from "framer-motion";
import { useState } from "react";
import { CustomerApi } from "../../api/customer.api";
import { toast } from "react-toastify"; 
import { LocalStorageUtils } from "utils/localstorage.utils";

const AddAddressPopup = ({
    onClose,
    onAddAddressComplete
}) => {
    const [village, setVillage] = useState(LocalStorageUtils.get(LocalStorageUtils.LOCAL_STORAGE_KEY.AREA_NAME) ?? '');
    const [userName, setUserName] = useState("");
    const [mobileNumber, setMobileNumber] = useState(LocalStorageUtils.get(LocalStorageUtils.LOCAL_STORAGE_KEY.USER)?.mobile?.slice(-10) ?? '');
    const [address, setAddress] = useState("");
    const [isMobileValid, setIsMobileValid] = useState(true);

    const handleMobileChange = (e) => {
      const value = e.target.value;
      let mobileNumber = value;

      if (
        value.length > 10 &&
        (value.startsWith("0") ||
          value.startsWith("+91") ||
          value.startsWith("91"))
      ) {
        mobileNumber = value.slice(-10);
      }
      setMobileNumber(mobileNumber);
      setIsMobileValid(mobileNumber.length === 10);
    };

      const handleAddAddress = async () => {
        // if (!mobileNumber || !userName || !address || !village) {
        if (!mobileNumber) {
          toast.error("please enter mobile number");
          return;
        }
        if (!address) {
          toast.error("please enter address");
          return;
        }
        if (!userName) {
          toast.error("please enter name");
          return;
        }
        if (!village) {
          toast.error("please enter village (गाँव)");
          return;
        }
    
        if (mobileNumber.length === 10 && address.trim() && userName.trim()) {
          // Address is valid, save it
          const addressData = {
            "name": userName,
            "mobile": mobileNumber,
            "addressLine1": address,
            "city": village,
          }
          const newAddress = await CustomerApi.createAddress(addressData);
    
          setMobileNumber("");
          setAddress("");
          setUserName("");
          setVillage("");
          onClose();
          onAddAddressComplete(newAddress.id);
        } else {
          toast.error("Please enter a valid mobile number, address, and name.");
        }
      };
    

    return (
        <motion.div
        className="add-address-popup"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
      >
        <input
          type="text"
          placeholder="Enter your village (गाँव)"
          value={village}
          onChange={(e) => setVillage(e.target.value)}
          className="input-field-for-address"
          required
        />
        <input
          type="text"
          placeholder="Enter your name (नाम)"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          className="input-field-for-address"
        />
        <input
          type="text"
          placeholder="Enter your mobile number (नंबर)"
          value={mobileNumber}
          onChange={handleMobileChange}
          maxLength="14"
          className="input-field-for-address"
          required
        />
        {!isMobileValid && mobileNumber && (
          <span className="error-text">
            Please enter a valid 10-digit mobile number.
          </span>
        )}

        <textarea
          placeholder="Enter your new address (पता)"
          value={address}
          className="input-field-for-address"
          onChange={(e) => setAddress(e.target.value)}
        />

        <button
          className="save-address-btn"
          onClick={handleAddAddress}
          disabled={!(isMobileValid && address.trim() && userName.trim())} // Disable if validation fails
        >
          Save Address
        </button>

        <button
          className="close-popup-btn"
          onClick={onClose}
        >
          Close
        </button>
      </motion.div>
    )
}

export default AddAddressPopup;